import axios from 'axios';
export const QUERY_STRING_PARAMETERS = {
    CHALLENGE: 'challenge',
};
export const validateCertificateIdentification = async (root, certificate, challenge) => axios
    .get(`${root}/legacy/minter/certificate/${certificate}/validate`, {
    params: {
        [QUERY_STRING_PARAMETERS.CHALLENGE]: challenge,
    },
})
    .then((r) => r.data.valid);
export const getCertificate = async (root, certificate) => axios.get(`${root}/legacy/minter/certificate/${certificate}`).then((r) => r.data);
export const forgotCertificatePassword = async (root, certificate, email) => axios.post(`${root}/legacy/minter/certificate/${certificate}/forgot-password`, {
    email: email,
});
export const approveCertificateIssuance = async (root, certificate, token, suggestedShareCode) => axios.post(`${root}/legacy/minter/certificate/${certificate}/approve`, {
    token: token,
    suggestedShareCode: suggestedShareCode,
});
export { StateType } from '@pok/minter-sdk';
export const updateShareCode = async (root, input) => axios.post(`${root}/legacy/minter/certificate/updateShareCode`, input).then(() => undefined);
//# sourceMappingURL=minter.js.map